// extracted by mini-css-extract-plugin
export default {"wrapper":"fullCompanyTimeLine_wrapper__-31MJ","header":"fullCompanyTimeLine_header__ebVmM"};